import { render, staticRenderFns } from "./BtnModal.vue?vue&type=template&id=3c8f883a&scoped=true&"
import script from "./BtnModal.vue?vue&type=script&lang=js&"
export * from "./BtnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f883a",
  null
  
)

export default component.exports